import(/* webpackMode: "eager" */ "/root/site/nuxinofront/src/app/(main)/products/[...slugs]/loading.tsx")